import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    userDetails:{}
  },
  reducers: {
    setUserDetails: (state, action) => {
      console.log("userDetails set:", action.payload);
       const info = action.payload || {};
      state.userDetails = {
        firstName: info.firstName,
        lastName: info.lastName,
        mobileNumber: info.mobileNumber,
        isMobileVerified: info.isMobileVerified,
        isEmailVerified:info.isEmailVerified,
        email: info.email || "",
        isActive: info.isActive ?? true,
      };
    },
  }
});

export const { setUserDetails } = userSlice.actions;
export default userSlice.reducer;